import { render } from "./DeleteAccessTokenModal.vue?vue&type=template&id=70fbfb8c"
import script from "./DeleteAccessTokenModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteAccessTokenModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/DeleteAccessTokenModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70fbfb8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70fbfb8c', __exports__)) {
    api.reload('70fbfb8c', __exports__)
  }
  
  module.hot.accept("./DeleteAccessTokenModal.vue?vue&type=template&id=70fbfb8c", () => {
    api.rerender('70fbfb8c', render)
  })

}


export default __exports__